<ph-dialog [open]="open" size="sm" [heading]="heading" icon="image" [noClose]="saving" (ph-close)="close()">
    <ph-stack>
        <ph-file-upload *ngIf="!file"
                        [accept]="accept"
                        [hint]="hint"
                        [disabled]="saving"
                        [error]="error"
                        (ph-files)="onFiles($event)"
                        (ph-reject)="onRejected($event)"></ph-file-upload>

        <ng-container *ngIf="file">
            <ph-toolbar justify="between">
                <ph-hint>Cropped image: {{ width }} x {{ height }}px</ph-hint>
                <ph-toolbar gap="tight" nowrap>
                    <ph-compact-button variant="stroke" icon="minus" aria-label="Zoom out" [disabled]="!loaded || busy" (click)="zoomOut()"></ph-compact-button>
                    <ph-compact-button variant="stroke" icon="plus" aria-label="Zoom in" [disabled]="!loaded || busy" (click)="zoomIn()"></ph-compact-button>
                </ph-toolbar>
            </ph-toolbar>
            <ph-alert *ngIf="loaded && underSized" status="warning" variant="lighter">{{ underSizedText }}</ph-alert>
            <image-cropper [imageFile]="file"
                           [aspectRatio]="aspectRatio"
                           [maintainAspectRatio]="true"
                           [containWithinAspectRatio]="true"
                           [transform]="transform"
                           [autoCrop]="false"
                           [resizeToWidth]="width"
                           [resizeToHeight]="height"
                           [cropperMinWidth]="width"
                           [cropperMinHeight]="height"
                           [disabled]="busy"
                           format="png"
                           output="base64"
                           (imageLoaded)="onImageLoaded()"
                           (cropperReady)="onCropperReady($event)"
                           (loadImageFailed)="onLoadFailed()"></image-cropper>
            <ph-link-button variant="primary" [disabled]="busy" (click)="reset()">Choose a different image</ph-link-button>
        </ng-container>

        <ph-alert *ngIf="error && file" status="error" variant="lighter">{{ error }}</ph-alert>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" type="button" [disabled]="saving" (click)="close()">Cancel</ph-button>
        <ph-button variant="primary" mode="filled" type="button" [disabled]="!loaded" [loading]="busy" (click)="submit()">{{ saveLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
